import { useState, useEffect } from 'react'
import api from '../services/api'
import { useAuth } from '../contexts/AuthContext'

export default function Produtos() {
    const { profile } = useAuth()
    const isMaster = profile?.user_role === 'master'
    const [companies, setCompanies] = useState([])
    const [selectedCompany, setSelectedCompany] = useState('')
    const [products, setProducts] = useState([])
    const [showForm, setShowForm] = useState(false)
    const [newProduct, setNewProduct] = useState('')

    useEffect(() => {
        if (isMaster) {
            api.get('/companies').then(r => setCompanies(r.data))
        } else {
            // Cliente vê apenas os produtos da própria empresa
            if (profile?.company_id) {
                setSelectedCompany(profile.company_id)
            }
        }
    }, [isMaster, profile])

    useEffect(() => {
        if (!selectedCompany) return
        api.get(`/products/${selectedCompany}`).then(r => setProducts(r.data))
    }, [selectedCompany])

    const handleCreate = async () => {
        if (!newProduct || !selectedCompany) return
        const { data } = await api.post('/products', {
            name: newProduct,
            company_id: selectedCompany
        })
        setProducts(prev => [...prev, data])
        setNewProduct('')
        setShowForm(false)
    }

    const handleDelete = async (id) => {
        await api.delete(`/products/${id}`)
        setProducts(prev => prev.filter(p => p.id !== id))
    }

    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold">Produtos / Serviços</h1>
                {selectedCompany && (
                    <button onClick={() => setShowForm(true)} className="bg-indigo-600 hover:bg-indigo-700 px-4 py-2 rounded-lg text-sm font-semibold transition">
                        + Novo Produto
                    </button>
                )}
            </div>

            {/* Seletor de empresa — só master */}
            {isMaster && (
                <div className="mb-6">
                    <select
                        className="bg-gray-800 rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 ring-indigo-500 w-full max-w-xs"
                        value={selectedCompany}
                        onChange={e => setSelectedCompany(e.target.value)}
                    >
                        <option value="">Selecione uma empresa</option>
                        {companies.map(c => (
                            <option key={c.id} value={c.id}>{c.name}</option>
                        ))}
                    </select>
                </div>
            )}

            {showForm && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                    <div className="bg-gray-900 rounded-xl p-6 w-full max-w-md border border-gray-700">
                        <h2 className="text-lg font-bold mb-4">Novo Produto / Serviço</h2>
                        <input
                            className="w-full bg-gray-800 rounded-lg px-3 py-2 mb-4 text-sm outline-none focus:ring-2 ring-indigo-500"
                            placeholder="Nome do produto *"
                            value={newProduct}
                            onChange={e => setNewProduct(e.target.value)}
                        />
                        <div className="flex gap-2">
                            <button onClick={handleCreate} className="flex-1 bg-indigo-600 hover:bg-indigo-700 py-2 rounded-lg text-sm font-semibold transition">Criar</button>
                            <button onClick={() => setShowForm(false)} className="flex-1 bg-gray-700 hover:bg-gray-600 py-2 rounded-lg text-sm transition">Cancelar</button>
                        </div>
                    </div>
                </div>
            )}

            {!selectedCompany && isMaster && (
                <p className="text-gray-500 text-center py-12">Selecione uma empresa para ver os produtos.</p>
            )}

            {selectedCompany && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {products.map(p => (
                        <div key={p.id} className="bg-gray-900 rounded-xl p-4 border border-gray-800 flex justify-between items-center hover:border-indigo-500/50 transition">
                            <span className="font-medium">{p.name}</span>
                            <button onClick={() => handleDelete(p.id)} className="text-gray-600 hover:text-red-400 transition text-sm">✕</button>
                        </div>
                    ))}
                    {products.length === 0 && (
                        <p className="text-gray-500 col-span-3 text-center py-12">Nenhum produto cadastrado ainda.</p>
                    )}
                </div>
            )}
        </div>
    )
}